"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _icon = _interopRequireDefault(require("../icon"));

var _validation = _interopRequireDefault(require("../messages/validation"));

var _messages = _interopRequireDefault(require("./messages"));

var _style = _interopRequireDefault(require("./style.css"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var calcPercent = function calcPercent(from, to) {
  return Math.round(from / to * 100);
};

var _ref = /*#__PURE__*/_jsx(_icon["default"], {
  name: "upload"
});

var FilePicker = /*#__PURE__*/function (_PureComponent) {
  _inherits(FilePicker, _PureComponent);

  var _super = _createSuper(FilePicker);

  function FilePicker() {
    var _this;

    _classCallCheck(this, FilePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      humanizeFileName: null,
      progress: 0,
      uploadError: null
    });

    _defineProperty(_assertThisInitialized(_this), "validateFileSize", function (size) {
      return size <= _this.props.sizeLimit;
    });

    _defineProperty(_assertThisInitialized(_this), "setHumanizeFileName", function (humanizeFileName) {
      return _this.setState({
        humanizeFileName: humanizeFileName
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setProgress", function (progress) {
      return _this.setState({
        progress: progress
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearProgress", function () {
      return _this.setState({
        progress: 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setError", function (message) {
      _this.clearProgress();

      if (_this.state.humanizeFileName) {
        _this.setState({
          uploadError: message
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearError", function () {
      return _this.setState({
        uploadError: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "uploadFile", function (file) {
      var _this$props = _this.props,
          input = _this$props.input,
          requestConfig = _this$props.requestConfig,
          responseGetter = _this$props.responseGetter;

      _this.setProgress(1);

      var formData = new FormData();
      formData.append(requestConfig.field, file);
      return _axios["default"].post(requestConfig.url, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        },
        onUploadProgress: function onUploadProgress(e) {
          return _this.setProgress(calcPercent(e.loaded * 0.95, e.total));
        } // -5% for api pending

      }).then(function (response) {
        input.onChange({
          target: {
            value: responseGetter(response.data)
          }
        });

        _this.setProgress(100);
      })["catch"](function (error) {
        _this.setError(error.response && error.response.data ? error.response.data.message : 'Error');
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      _this.clearError();

      if (!e.target.files.length) {
        return false;
      }

      var _this$props2 = _this.props,
          intl = _this$props2.intl,
          sizeLimit = _this$props2.sizeLimit;
      var file = e.target.files[0];

      if (!_this.validateFileSize(file.size)) {
        return _this.setError(intl.formatMessage(_messages["default"].fileTooBig, {
          count: 1,
          size: "".concat(sizeLimit / 1000000, " MB")
        }));
      }

      _this.setHumanizeFileName(file.name);

      return _this.uploadFile(file);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function () {
      _this.setHumanizeFileName(null);

      _this.clearProgress();

      _this.clearError();

      _this.props.input.onChange({
        target: {
          value: null
        }
      });
    });

    return _this;
  }

  _createClass(FilePicker, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          input = _this$props3.input,
          meta = _this$props3.meta,
          accept = _this$props3.accept,
          disabled = _this$props3.disabled,
          dataId = _this$props3.dataId;
      return /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx("div", {
        "data-id": dataId,
        className: cx('xsui-file-picker', input.value && 'xsui-file-picker--filled', this.isUploading && 'xsui-file-picker--uploading', disabled && 'xsui-file-picker--disabled', (this.state.uploadError || meta.touched && meta.error) && 'xsui-file-picker--error')
      }, void 0, !this.isUploading && /*#__PURE__*/_jsx("label", {
        className: cx('xsui-file-picker__input')
      }, void 0, /*#__PURE__*/_jsx("input", {
        type: "file",
        accept: accept.join(','),
        onChange: this.handleChange
      })), /*#__PURE__*/_jsx("div", {
        className: cx('xsui-file-picker__icon')
      }, void 0, this.state.humanizeFileName ? /*#__PURE__*/_jsx(_icon["default"], {
        name: this.isUploading ? 'circle-remove-mini' : 'delete',
        hoverable: true,
        onClick: this.handleClear
      }) : _ref), /*#__PURE__*/_jsx("div", {
        className: cx('xsui-file-picker__label')
      }, void 0, this.state.humanizeFileName || 'Upload file'), this.isUploading && /*#__PURE__*/_jsx("div", {
        className: cx('xsui-file-picker__progress'),
        style: {
          width: "".concat(this.state.progress, "%")
        }
      })), this.state.uploadError && /*#__PURE__*/_jsx(_validation["default"], {}, void 0, this.state.uploadError), meta.touched && meta.error && /*#__PURE__*/_jsx(_validation["default"], {}, void 0, meta.error));
    }
  }, {
    key: "isUploading",
    get: function get() {
      return !!this.state.humanizeFileName && this.state.progress > 0 && this.state.progress < 100;
    }
  }]);

  return FilePicker;
}(_react.PureComponent);

_defineProperty(FilePicker, "defaultProps", {
  meta: {
    touched: false,
    error: null
  },
  responseGetter: function responseGetter(data) {
    return data;
  },
  accept: [],
  sizeLimit: 1000000,
  disabled: false
});

var _default = (0, _reactIntl.injectIntl)(FilePicker);

exports["default"] = _default;